"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
const Icon_1 = require("../Icon");
/**
 * Checkbox component
 *
 * @visibleName Checkbox
 */
const Checkbox = ({ children, className, value = false, disabled = false, color = '075', id, onChange = () => { } }) => {
    const [checked, setChecked] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        checked !== value;
        setChecked(value);
    }, [value]);
    const clsName = (0, lib_1.classnames)(className, (0, lib_1.bem)('checkbox', (0, lib_1.use)(checked, '--checked')));
    function handleChange() {
        setChecked(!checked);
        onChange(!checked);
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'checkbox__wrapper', onClick: disabled ? undefined : handleChange }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: clsName }, { children: [(0, jsx_runtime_1.jsx)("input", { disabled: disabled, className: 'checkbox__input', type: 'checkbox', checked: checked, onChange: handleChange, id: id }, void 0), checked && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: 'check', className: 'checkbox__check' }, void 0)] }), void 0), children ? (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'checkbox__label' }, { children: children }), void 0) : null] }), void 0));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map